import Box from '../shared/layouts/Box';
import Flex from '../shared/layouts/Flex';
import DropdownIcon from 'imagesUwKluis/svg/dropdown.svg';
import {useIconLibrary} from "../../hooks/useIconLibrary";

const ExternalMenuItem = ({ to, title, onClick, Icon }) => {
  const { LinkIcon } = useIconLibrary();
  const MenuItemIcon = Icon || LinkIcon;

  return (
    <a
      href={to}
      onClick={onClick}
      target="_blank"
      rel="noopener noreferrer"
      css={({ colors }) => ({
        display: 'block',
        color: colors.primaryFont,
        cursor: 'pointer',
        'svg path': { fill: colors.primaryFont }
      })}
    >
      <Flex
        pl="l"
        alignItems="center"
        height="56px"
        css={({ colors }) => ({
          '> svg': {
            flexShrink: 0,
          },
          '&:hover': {
            background: colors.primaryActive,
            color: colors?.primaryContrast,

            'svg path': {
              fill: colors?.primaryContrast
            }
          }
        })}
      >
        <MenuItemIcon width="2rem" height="2rem" />
        <Box pl="m">{title}</Box>
        <DropdownIcon
          width="16px"
          height="16px"
          css={{
            marginLeft: 'auto',
            marginRight: '16px',
            transform: 'rotate(-90deg)'
          }}
        />
      </Flex>
    </a>
  );
}

export default ExternalMenuItem;
